import React from "react";
import { Form, Input, Button, message } from "antd";
import {
  MailOutlined,
  LockOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import logo from "../../../Assets/Images/logo.svg";
import verifiedIcon from "../../../Assets/Icons/verified_user.svg";
import logoCompany from "../../../Assets/Icons/companylogo.svg";
import { login } from "../../../API/auth";
import PortalConfig from "../../../Utlis/PortalConfig";
import "./style.css";

const Login = ({ setUser, portal }) => {
  const config = PortalConfig[portal];
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    let res;
    let tenantType;
    for (const type of config.loginTenantTypes) {
      tenantType = type;
      res = await login({ ...values, tenant_type: type });
      if (!res?.data?.tenant_type || res?.status === 200) break;
    }
    setLoading(false);
    if (res?.status === 200 && res?.data?.application_under_review) {
      if (config.requestSubmittedRoute) {
        navigate(config.requestSubmittedRoute, { state: { fromLogin: true } });
      } else {
        message.info("Your application is currently under review.");
      }
    } else if (res?.status === 200 && res?.data?.two_factor_required) {
      setUser(config.userValue);
      navigate("/two-factor-authentication", {
        state: {
          tempToken: res.data.temp_token,
          email: values.email,
          password: values.password,
          tenantType: res.data.tenant_type || tenantType,
        },
      });
    } else if (res?.data?.tenant_type) {
      message.error(
        `This account isn't registered as ${config.roleLabel}. Please use the correct login screen for your role.`,
      );
    } else {
      message.error(res?.data?.detail || "Invalid email or password.");
    }
  };

  const handleSignUp = () => {
    if (!config.loginBackSetsUserOnly) setUser(config.userValue);
    navigate(config.signUpRoute);
  };

  const handleForgotPassword = () => {
    if (!config.loginBackSetsUserOnly) setUser(config.userValue);
    navigate(config.forgotPasswordRoute);
  };

  const handleBack = () => {
    setUser(config.userValue);
    navigate("/selection");
  };

  return (
    <div className="login" data-portal={portal}>
      <div className="login-page">
        <Button
          className="login-back"
          icon={<ArrowLeftOutlined />}
          onClick={handleBack}
        />

        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="login-card">
          <div className="top-gradient"></div>

          <div className="content-heading">{config.loginHeading}</div>
          <div className="sub-heading">
            Authenticate to access the dashboard
          </div>

          <Form
            name="login"
            layout="vertical"
            autoComplete="off"
            onFinish={onFinish}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Enter a valid email!" },
              ]}
            >
              <Input placeholder="Enter your email" prefix={<MailOutlined />} />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please enter your password!" },
              ]}
            >
              <Input.Password
                placeholder="Enter your password"
                prefix={<LockOutlined />}
              />
            </Form.Item>

            <div className="forget-password" onClick={handleForgotPassword}>
              Forgot Password?
            </div>

            <div className="two-factor">
              <div className="two-factor-wrapper">
                <div className="icon">
                  <img src={verifiedIcon} alt="verified" />
                </div>
                <div className="wrapper">
                  <div className="heading">{config.loginTwoFactorTitle}</div>
                  <div className="sub-heading">
                    {config.loginTwoFactorSubtitle}
                  </div>
                </div>
              </div>
            </div>
            <Button
              type="primary"
              htmlType="submit"
              className="submit-button"
              loading={loading}
            >
              {config.loginSubmitLabel}
            </Button>
            {config.signUpRoute && (
              <div className="sign-up-link">
                Don't you have an account?
                <span onClick={handleSignUp}>Sign Up</span>
              </div>
            )}
          </Form>
        </div>
        <div className="logo-wrapper">
          <img src={logoCompany} alt="Logo Icon" className="logo-icon" />
          <div className="text">
            Powered by <span>CouSync</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
